/* ═══════════ THE DATA HUB PAGE SHELL (hub redesign, Sept 29 2026) ═══════════
   Loaded by sections/ff-data-hub.liquid with defer, before Chart.js, so the bar works at once.
   Everything here reads numbers the panels already load. It never calls
   Supabase or the portal itself, so it cannot slow the page or change a
   number. Four jobs:
   1. The bar under the title jumps to each group and lights the one you
      are reading. Fold all folds or opens every panel at once.
   2. The Insights cards (Jan: "nothing really needs me", so they inform, and a dot
      marks only a card with something waiting for him): heroes waiting for approval (the queue counts),
      client messages and orders (the commission portal, once this
      browser is signed in to the studio), whether commission turns are
      running (the waitlist's own power button), and the step where
      Quest 1 loses the most players (its funnel).
   3. The one line summary on each folded panel, read from the first
      chips the panel painted.
   4. The DM tools range buttons, which drive that panel's own dropdown.
   Every lookup tolerates a missing panel, because fixtures and older
   copies of the page load only some of them. */
(function(){
  var main=document.getElementById("fh-main");if(!main)return;
  var S={};
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function txt(e){return e?String(e.textContent||"").replace(/\s+/g," ").trim():""}
  function fmt(x){return (Number(x)||0).toLocaleString()}

  /* ---- 1. the bar ---- */
  var bar=$("#fh-bar",main);
  function barOffset(){return (bar?bar.getBoundingClientRect().height:0)+26}
  function jump(target,flash){
    if(!target)return;
    if(target.classList.contains("fh-panel")&&window.ffHubFold)ffHubFold.open(target);
    var y=target.getBoundingClientRect().top+(window.pageYOffset||0)-barOffset();
    window.scrollTo(0,Math.max(0,y));
    if(flash&&target.classList.contains("fh-panel")){
      target.classList.remove("is-flash");void target.offsetWidth;target.classList.add("is-flash");
      setTimeout(function(){target.classList.remove("is-flash")},1400);
    }
  }
  var links=$$("#fh-nav a[href^='#']",main);
  links.forEach(function(a){
    a.addEventListener("click",function(e){
      var t=document.getElementById(a.getAttribute("href").slice(1));
      if(!t)return;
      e.preventDefault();jump(t,false);
    });
  });
  var heads=$$(".fh-ghead[id]",main),spyQueued=false;
  function spy(){
    spyQueued=false;
    var line=barOffset()+30,on=null;
    heads.forEach(function(h){if(h.getBoundingClientRect().top<=line)on=h});
    links.forEach(function(a){a.classList.toggle("on",!!on&&a.getAttribute("href")==="#"+on.id)});
  }
  window.addEventListener("scroll",function(){if(!spyQueued){spyQueued=true;requestAnimationFrame(spy)}},{passive:true});
  var foldAll=$("#fh-foldall",main);
  function paintFoldAll(){
    if(!foldAll||!window.ffHubFold)return;
    var open=ffHubFold.anyOpen(),label=foldAll.querySelector("[data-fold-text]");
    if(label)label.textContent=open?"Fold all":"Open all";
    foldAll.setAttribute("aria-label",open?"Fold every panel":"Open every panel");
    foldAll.classList.toggle("is-folded",!open);
  }
  if(foldAll)foldAll.addEventListener("click",function(){if(window.ffHubFold){ffHubFold.setAll(ffHubFold.anyOpen());paintFoldAll()}});
  var refresh=$("#fh-refresh",main);
  if(refresh)refresh.addEventListener("click",function(){refresh.classList.remove("spin");void refresh.offsetWidth;refresh.classList.add("spin")});

  /* ---- 2. insights ---- */
  function card(key,o){
    var c=$('.fh-need[data-need="'+key+'"]',main);if(!c)return;
    function set(sel,v){var e=c.querySelector(sel);if(e&&e.textContent!==v)e.textContent=v}
    set("[data-v]",String(o.v));set("[data-l]",o.l||"");set("[data-s]",o.s||"");if(o.a)set("[data-a]",o.a);
    var v=c.querySelector("[data-v]");if(v)v.classList.toggle("sm",String(o.v).length>8);
    c.setAttribute("data-tone",o.tone||"");
    c.setAttribute("data-ready","1");
    /* the dot: only when something is actually waiting for Jan on this card */
    c.setAttribute("data-attn",o.attn?"1":"0");
    var sr=c.querySelector(".fh-sr");if(!sr){sr=document.createElement("span");sr.className="fh-sr";c.appendChild(sr)}
    sr.textContent=o.attn?" (waiting for you)":"";
    paintAttn();
  }
  /* The line under Insights counts the dots, so a glance says whether anything waits. */
  function paintAttn(){
    var line=document.getElementById("fh-needs-line");if(!line)return;
    var cards=$$(".fh-need",main),ready=cards.filter(function(c){return c.getAttribute("data-ready")}).length;
    var n=cards.filter(function(c){return c.getAttribute("data-attn")==="1"}).length;
    var t=n?(n===1?"1 thing is waiting for you. It has a dot.":n+" things are waiting for you. They have a dot.")
      :(ready?"Nothing is waiting for you right now.":"Reading orders, the quest, the waitlist and the Hall.");
    if(line.textContent!==t)line.textContent=t;
  }
  function badge(g,v){var b=$('#fh-nav a[data-g="'+g+'"] [data-badge]',main);if(b)b.textContent=v>0?fmt(v):""}
  function chipLine(c){
    if(!c)return "";
    var k=c.getAttribute("data-short")||txt(c.querySelector(".ck")).replace(/\s+·\s+(\d+\s*[hd]|all time|today)$/i,"");
    var v=txt(c.querySelector(".cv"));
    return k&&v?k+" "+v:"";
  }
  function chips(id,idx){
    var b=document.getElementById(id);if(!b)return "";
    var c=b.querySelectorAll(".fh-chip");
    return idx.map(function(i){return chipLine(c[i])}).filter(Boolean).join(" · ");
  }
  function paintQueue(d){
    var w=d.waiting||0;
    card("queue",w?{v:fmt(w),l:w===1?"hero waiting for your approval":"heroes waiting for your approval",
        s:d.rejected?fmt(d.rejected)+" rejected and parked":"",a:"Review them",tone:"act",attn:true}
      :{v:"0",l:"heroes waiting",s:"The queue is clear.",a:"Open the queue",tone:"ok"});
    badge("hall",w);
  }
  function paintCrm(d){
    if(d.state==="signedout"){card("crm",{v:"Sign in",l:"to see your orders here",s:"Uses your studio login, once per browser.",a:"Sign in",tone:""});badge("customers",0);return}
    if(d.state==="error"){card("crm",{v:"Not loaded",l:"your orders did not load",s:"Refresh to try again.",a:"Open the panel",tone:"hold"});return}
    var u=d.unread||0,late=d.overdue||0,open=d.open||0;
    card("crm",{v:fmt(u),l:u===1?"new message from a client":"new messages from clients",
      s:[late?fmt(late)+" overdue":"",fmt(open)+" open order"+(open===1?"":"s"),d.soon?fmt(d.soon)+" due this week":"",d.cases?fmt(d.cases)+" to double-check":""].filter(Boolean).join(" · "),
      a:"See orders",tone:late?"warn":((u||d.cases)?"act":"ok"),attn:!!(u||late||d.cases)});
    badge("customers",u);
  }
  function paintQ1(d){
    if(d.none){card("q1",{v:"0",l:d.starts?"players left partway":"players in this window",s:[d.ver,d.tag].filter(Boolean).join(" · "),a:"Open Quest 1",tone:d.starts?"ok":""});return}
    card("q1",{v:fmt(d.gone)+" left",l:"at "+d.label+(d.gate&&!/email/i.test(d.label)?", the email step":""),
      s:d.rate+"% of the "+fmt(d.of)+" who got there · "+d.ver+" · "+d.tag,a:"See where they leave",tone:"act"});
  }
  function paintWl(){
    var p=document.getElementById("wl-power");if(!p)return;
    var t=txt(p),running=/^running/i.test(t),paused=/^paused/i.test(t);
    if(!running&&!paused)return; /* still loading, or waiting on a second press */
    card("wl",{v:running?"Running":"Paused",l:"commission turns",s:chips("wl-chips",[0,1]),a:"Open the waitlist",tone:running?"ok":"hold"});
  }
  $$(".fh-need[data-go]",main).forEach(function(c){
    c.addEventListener("click",function(){jump($(c.getAttribute("data-go"),main),true)});
  });

  /* ---- 3. folded panel summaries ---- */
  function wlState(){var t=txt(document.getElementById("wl-power"));return /^running/i.test(t)?"Turns running":(/^paused/i.test(t)?"Turns paused":"")}
  var PEEK=[
    ["fh-portal",function(){var d=S.crm;if(!d)return "";if(d.state==="signedout")return "Sign in to see orders";if(d.state==="error")return "Orders did not load";
      return [fmt(d.open||0)+" open orders",d.unread?fmt(d.unread)+" new messages":"",d.overdue?fmt(d.overdue)+" overdue":"",d.cases?fmt(d.cases)+" to double-check":""].filter(Boolean).join(" · ")}],
    ["fh-q1",function(){var d=S.q1leak,s=chips("q1-chips",[0,1,2]);return s+(s&&d&&!d.none?" · most leave at "+String(d.label).replace(/^(P\d+)\s.*$/,"$1"):"")}],
    ["fh-fp",function(){return chips("fp-chips",[1,2])}],
    ["fh-wl",function(){return [wlState(),chips("wl-chips",[0])].filter(Boolean).join(" · ")}],
    ["fh-repeat-customers",function(){return "Verified D&D buyers who skip the line"}],
    ["fh-product-waitlists",function(){return "Waitlists for other products"}],
    ["fh-queue",function(){var d=S.queue;if(!d)return "";return (d.waiting?fmt(d.waiting)+" waiting":"The queue is clear")+(d.rejected?" · "+fmt(d.rejected)+" rejected":"")}],
    ["fh-hall",function(){return chips("hall-chips",[0,1])}],
    ["fh-hp",function(){return chips("hp-chips",[0,1])}],
    ["fh-bg",function(){return chips("bg-chips",[0,1])}],
    ["fh-bga",function(){return chips("bga-chips",[0,4])}],
    ["fh-camp",function(){return chips("camp-chips",[0,3])}],
    ["fh-dm",function(){return chips("dm-chips",[2,4])}],
    ["fh-book",function(){var d=S.book;if(!d)return "";if(d.none)return "Not shared yet";return (d.waiting?fmt(d.waiting)+" waiting":"Nothing waiting")+" · "+fmt(d.kept||0)+" in the book"}],
    ["fh-q2",function(){return chips("q2-chips",[0,1])}],
    ["fh-tickets",function(){return chips("tickets-chips",[0,1])}],
    ["fh-hearts",function(){return chips("hearts-chips",[0,1])}]
  ];
  function peekAll(){
    PEEK.forEach(function(pair){
      var p=$("."+pair[0],main),s=p&&p.querySelector(".fh-pan-sum");if(!s)return;
      var v="";try{v=pair[1]()||""}catch(e){}
      if(s.textContent!==v){s.textContent=v;s.title=v}
    });
  }
  var queued=0;
  function soon(){if(queued)return;queued=setTimeout(function(){queued=0;peekAll();paintWl()},120)}
  if(window.MutationObserver){
    var mo=new MutationObserver(soon);
    ["q1-chips","fp-chips","wl-chips","hall-chips","hp-chips","bg-chips","bga-chips","camp-chips","dm-chips","q2-chips","tickets-chips","hearts-chips"].forEach(function(id){
      var e=document.getElementById(id);if(e)mo.observe(e,{childList:true,subtree:true,characterData:true});
    });
    var pw=document.getElementById("wl-power");if(pw)mo.observe(pw,{attributes:true,childList:true,subtree:true,characterData:true});
  }
  function onStat(d){
    if(!d||!d.key)return;
    S[d.key]=d;
    if(d.key==="queue")paintQueue(d);
    else if(d.key==="crm")paintCrm(d);
    else if(d.key==="q1leak")paintQ1(d);
    else if(d.key==="book")badge("games",d.waiting||0);
    soon();
  }
  window.addEventListener("ffhub:stat",function(e){onStat(e.detail)});
  var early=window.__ffhubStats||{};for(var k in early)onStat(early[k]);
  window.addEventListener("ffhub:fold",function(){paintFoldAll();soon()});
  paintFoldAll();
  /* this script loads deferred, so a panel may already have painted */
  soon();

  /* A card whose panel never answered says so, rather than showing its
     loading dots forever. The clock starts when the hub opens. */
  var watched=false;
  function whenOpen(){
    if(watched||main.style.display==="none")return;
    watched=true;
    setTimeout(function(){
      $$(".fh-need:not([data-ready])",main).forEach(function(c){
        var v=c.querySelector("[data-v]"),l=c.querySelector("[data-l]"),s=c.querySelector("[data-s]");
        if(v)v.textContent="No answer";if(l)l.textContent="this part did not load yet";if(s)s.textContent="Refresh to try again.";
        c.setAttribute("data-tone","hold");
      });
      var line=document.getElementById("fh-needs-line");
      if(line&&!$$(".fh-need[data-attn='1']",main).length&&$$(".fh-need:not([data-ready])",main).length)line.textContent="Some of this did not load yet. Refresh to try again.";
    },25000);
  }
  if(window.MutationObserver)new MutationObserver(whenOpen).observe(main,{attributes:true,attributeFilter:["style"]});
  whenOpen();

  /* ---- 4. DM tools range buttons ---- */
  (function(){
    var g=document.getElementById("dm-range"),s=document.getElementById("dm-days");if(!g||!s)return;
    function paint(){$$("button[data-dmd]",g).forEach(function(b){var on=b.getAttribute("data-dmd")===s.value;b.classList.toggle("on",on);b.setAttribute("aria-pressed",on?"true":"false")})}
    g.addEventListener("click",function(e){
      var b=e.target&&e.target.closest?e.target.closest("button[data-dmd]"):null;
      if(!b||b.getAttribute("data-dmd")===s.value)return;
      s.value=b.getAttribute("data-dmd");paint();
      try{s.dispatchEvent(new Event("change"))}catch(x){}
    });
    paint();
  })();
})();
